import * as angular from "angular";
import { PrivacyNotice } from "../models/privacy-notice.model";
import { PrivacyNoticeService } from "../services/privacy-notice.service";

export class PrivacyNoticeDataProvider {
    private allPromise: any;
    private pendingPromise: any;
    private pendingPrivacyNotice: any;
    private service: PrivacyNoticeService;
    private $q: any;

    public privacyNotices = null;

    constructor($q: any, PrivacyNoticeService: PrivacyNoticeService) {
        this.service = PrivacyNoticeService;
        this.$q = $q;
    }

    create(privacyNotice) {
        const deferred = this.$q.defer();

        this.service.create(privacyNotice).then(
            (response) => {
                const json = response["data"];
                if (json.success) {
                    deferred.resolve(new PrivacyNotice(json.data));
                } else {
                    deferred.reject(json);
                }
            },
            (error) => deferred.reject(error)
        );

        return deferred.promise;
    }

    getAllPrivacyNotices() {
        const deferred = this.$q.defer();

        if (this.privacyNotices) {
            deferred.resolve(this.privacyNotices);
            this.allPromise = deferred.promise;

            return this.allPromise;
        } else if (this.allPromise) {
            return this.allPromise;
        } else {
            this.service.all().then(
                (response) => {
                    const json = response["data"];
                    this.privacyNotices = [];

                    for (let i = 0; i < json.data.length; i++) {
                        this.privacyNotices.push(
                            new PrivacyNotice(json.data[i])
                        );
                    }

                    deferred.resolve(this.privacyNotices);
                },
                (error) => {
                    this.privacyNotices = [];
                    deferred.reject(error);
                }
            );

            this.allPromise = deferred.promise;

            return this.allPromise;
        }
    }

    pending(): Promise<PrivacyNotice> {
        const deferred = this.$q.defer();

        if (this.pendingPrivacyNotice) {
            deferred.resolve(this.pendingPrivacyNotice);
            this.pendingPromise = deferred.promise;

            return this.pendingPromise;
        } else if (this.pendingPromise) {
            return this.pendingPromise;
        } else {
            this.service.pending().then(
                (response) => {
                    const json = response["data"];
                    this.pendingPrivacyNotice = null;

                    if (json.data) {
                        this.pendingPrivacyNotice = new PrivacyNotice(
                            json.data
                        );
                    }

                    deferred.resolve(this.pendingPrivacyNotice);
                },
                (error) => {
                    this.pendingPrivacyNotice = null;
                    deferred.reject(error);
                }
            );

            this.pendingPromise = deferred.promise;

            return this.pendingPromise;
        }
    }

    acknowledge(privacyNotice) {
        const deferred = this.$q.defer();

        this.service.acknowledge(privacyNotice).then((response) => {
            const json = response["data"];
            if (json.success && json.data.upnid) {
                deferred.resolve(privacyNotice);
            } else {
                deferred.reject(json);
            }
        });

        return deferred.promise;
    }

    clearAll() {
        this.privacyNotices = null;
        this.pendingPrivacyNotice = null;
        this.allPromise = null;
        this.pendingPromise = null;
    }
}

angular
    .module("vcDataProvider")
    .service("PrivacyNoticeDataProvider", PrivacyNoticeDataProvider);
